export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "6 OF THE BEST - Châteaus in France",
    "shortTitle": "",
    "description": "",
    "width": 1200,
    "height": 848,
    "currentLanguage": "EN",
    "languages": [],
    "basePath": "/6ofthebest/chateaus",
    "companyLogo": "1-logo.png",
    "publishURL": "https://publish.ironstone.ltd/6ofthebest/chateaus/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": false,
      "mobileSwitch": false
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 38px; left: 385px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/1-t1.png" id="1-title">
      <img style="position:absolute; top: 172px;left: 353px;;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/1-t2.png" id="1-sub-1">

      <img style="position:absolute; top: 731px; left: 1034px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/1-logo.png" id="1-logo" >

      <div class="addContentLink" style="bottom: 29px;
      left: 1030px;
      width: 143px;
      height: 91px;">
        <a href="http://www.sotb.online/" target="_blank"></a></div>


      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(idOf("1-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("1-sub-1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.4")
          .fromTo(idOf("1-logo"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg1Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "OF THE BEST CHÂTEAUS IN FRANCE  SIX OF THE BEST"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 38px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-t1.png" id="2-title">



      

      <div id="2-sig" class="abs noOverflow" style="top:598px;left:674px;height:63px;width:123px">
          <img class="halfScale" src="/6ofthebest/chateaus/static/_content/2-sig.png">
        </div>


      <img style="position:absolute; top: 710px;
      left: 680px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-logo.png" id="2-logo" >

      <img style="position:absolute; top: 432px;
      left: 340px;display: none;"  class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-bal.jpg" id="2-bal">
<img style="position:absolute; top: 459px;
left: 290px;" onclick="pin1Open()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/castle.png" id="2-bal">

      <img style="position:absolute; top: 420px;
      left: 6px;display: none;"  class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-bas.jpg" id="2-bas">
<img style="position:absolute; top: 442px;
left: 233px;" onclick="pin2Open()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/castle.png" id="2-bas">

      <img style="position:absolute; top: 515px;
      left: 391px;display: none;"  class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-rib.jpg" id="2-rib">
<img style="position:absolute; top: 540px;
left: 341px;" onclick="pin3Open()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/castle.png" id="2-rib">

      <img style="position:absolute; top: 263px;
      left: 384px;display: none;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-lys.jpg" id="2-lys">
<img style="position:absolute; top: 283px;
left: 332px;" onclick="pin4Open()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/castle.png" id="2-lys">

      <img style="position:absolute; top: 497px;
      left: 29px;display: none;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-ten.jpg" id="2-ten">
 <img style="position:absolute; top: 521px;
left: 257px;" onclick="pin5Open()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/castle.png" id="2-ten">

      <img style="position:absolute; top: 329px;
      left: 259px;display: none;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/2-norm.jpg" id="2-norm">
<img style="position:absolute; top: 352px;
left: 209px;" onclick="pin6Open()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/castle.png" id="2-norm">

<div class="addContentLink" style="top: 420px; left: 6px; width: 223px; height: 90px;" onclick="Publish.goToPage(3)"></div>

<div class="addContentLink" style="top: 263px; left: 384px; width: 223px; height: 90px;" onclick="Publish.goToPage(5)"></div>

<div class="addContentLink" style="top: 432px; left: 340px; width: 223px; height: 90px;" onclick="Publish.goToPage(7)"></div>

<div class="addContentLink" style="top: 497px; left: 29px; width: 223px; height: 90px;" onclick="Publish.goToPage(9)"></div>

<div class="addContentLink" style="top: 329px; left: 259px; width: 223px; height: 90px;" onclick="Publish.goToPage(11)"></div>

<div class="addContentLink" style="top: 515px;left: 391px; width: 223px; height: 90px;" onclick="Publish.goToPage(13)"></div>

      <div class="addContentLink" style="bottom: 270px;left: 835px;width: 231px;height: 16px;">
        <a href="http://www.channel4.com/programmes/escape-to-the-chateau-diy" target="_blank"></a></div>

        <div class="addContentLink" style="bottom: 49px;
        left: 678px;
        width: 151px;
        height: 97px;">
          <a href="http://www.sotb.online/" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.fromTo(idOf("2-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("2-sig"), 0.6, {width:"0px"}, {width:"123px", ease: Power2.easeOut}, "-=0.4")
          .fromTo(idOf("2-logo"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks();
        }

function pin1Open() {
   var x = document.getElementById("2-bal");
   if (x.style.display === "none") {
       x.style.display = "block";
       document.getElementById("2-bas").style.display  = "none";
       document.getElementById("2-rib").style.display  = "none";
       document.getElementById("2-lys").style.display  = "none";
       document.getElementById("2-ten").style.display  = "none";
       document.getElementById("2-norm").style.display  = "none";
   } else {
       x.style.display = "none";
   }
}

function pin2Open() {
   var x = document.getElementById("2-bas");
   if (x.style.display === "none") {
       x.style.display = "block";
       document.getElementById("2-bal").style.display  = "none";
       document.getElementById("2-rib").style.display  = "none";
       document.getElementById("2-lys").style.display  = "none";
       document.getElementById("2-ten").style.display  = "none";
       document.getElementById("2-norm").style.display  = "none";
   } else {
       x.style.display = "none";
   }
}

function pin3Open() {
   var x = document.getElementById("2-rib");
   if (x.style.display === "none") {
       x.style.display = "block";
       document.getElementById("2-bal").style.display  = "none";
       document.getElementById("2-bas").style.display  = "none";
       document.getElementById("2-lys").style.display  = "none";
       document.getElementById("2-ten").style.display  = "none";
       document.getElementById("2-norm").style.display  = "none";
   } else {
       x.style.display = "none";
   }
}

function pin4Open() {
   var x = document.getElementById("2-lys");
   if (x.style.display === "none") {
       x.style.display = "block";
       document.getElementById("2-bal").style.display  = "none";
       document.getElementById("2-bas").style.display  = "none";
       document.getElementById("2-rib").style.display  = "none";
       document.getElementById("2-ten").style.display  = "none";
       document.getElementById("2-norm").style.display  = "none";
   } else {
       x.style.display = "none";
   }
}

function pin5Open() {
   var x = document.getElementById("2-ten");
   if (x.style.display === "none") {
       x.style.display = "block";
       document.getElementById("2-bal").style.display  = "none";
       document.getElementById("2-bas").style.display  = "none";
       document.getElementById("2-rib").style.display  = "none";
       document.getElementById("2-lys").style.display  = "none";
       document.getElementById("2-norm").style.display  = "none";
   } else {
       x.style.display = "none";
   }
}

function pin6Open() {
   var x = document.getElementById("2-norm");
   if (x.style.display === "none") {
       x.style.display = "block";
       document.getElementById("2-bal").style.display  = "none";
       document.getElementById("2-bas").style.display  = "none";
       document.getElementById("2-rib").style.display  = "none";
       document.getElementById("2-lys").style.display  = "none";
       document.getElementById("2-ten").style.display  = "none";
   } else {
       x.style.display = "none";
   }
}

      `,
      "searchText": "CONTENTS Click the Château icons to visit the Château page or hover to find out more  Welcome to Château Escapes, from Six of The Best Online Our Team have hand-picked six of their favourite Châteaus with English speaking owners that France has to offer. These carefully selected Châteaus are situated throughout France and give you access to a wide range of activities, beautiful gardens and historic grounds to help you enjoy your French break. The Château’s vary and offer tennis courts, private chapels, romantic walled gardens and stunning views suitable for Weddings, Aniversaries, Romantic breaks, and Family holidays. Whichever Château you chose to stay in they all offer an excellent base to explore the fantastic, historic French countryside. If you wish to get to know the owners a little better, many of the Château’s have recently featured on Channel 4’s Escape to the Château.  On Behalf of Six of the best online"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `

      <img style="position:absolute; top: 730px;
      left: 140px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/3-text.png" id="3-text" >

      <img style="position:absolute; top: 0px;
      right: 35px; display: none; z-index:2;" class="1-title" src="/6ofthebest/chateaus/static/_content/3-contact.jpg" id="3-btn-text">

      <div class="addContentLink" style="bottom: 722px; left: 947px; width: 128px; height: 21px; z-index:3">
        <a href="http://www.basmaignee.com" target="_blank"></a></div>

      <img style="position:absolute; top: 48px;
      left: 309px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/3-t1.png" id="3-title">

      <img style="position:absolute; top: 0px;
      right: -35px;" onclick="threeSlide()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/3-btn.jpg" id="3-contact">

      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.fromTo(idOf("3-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("3-text"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.4")
        }

        function threeSlide() {
          var x = document.getElementById("3-btn-text");
          if (x.style.display === "none" ) {
              x.style.display = "block";
              
          } else {
              x.style.display = "none";
          }
       }

        function onPageLeave() {
          pg3Anim.stop();
          removeContentLinks();
        }

        
      `,
      "searchText": "The château sits in over 60 acres of parkland, which contains a private chapel, a traditional walled garden, six cottages, and 25 acres of forest with a secluded lake. Facilities include tennis court, woodland walks, local wildlife spotting, and much more.​  phone  Château de la Basmaignée is located in the Mayenne area, North West of France, close to the historic village of Montenay. With its rich history of Royalty and Nobility, France is home to countless châteaux, and the Pays de la Loire region holds many of them.  Contact  Château de la Basmaignée"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.png",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 664px;
      left: 264px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-url.png" id="4-url">
      <div class="addContentLink" style="bottom: 114px;
      left: 262px;
      width: 660px;
      height: 71px;
      ">
        <a href="http://www.basmaignee.com" target="_blank"></a></div>

      <img style="position:absolute; top: 140px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img1.png" id="4-img1">
      <img style="position:absolute; top: 346px;
      left: 98px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img2.png" id="4-img2">
      <img style="position:absolute; top: 309px;
      left: 330px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img3.png" id="4-img3">
      <img style="position:absolute; top: 120px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img4.png" id="4-img4">
      <img style="position:absolute; top: 305px;
      left: 548px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img5.png" id="4-img5">
      <img style="position:absolute; top: 93px;
      left: 723px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img6.png" id="4-img6">
      <img style="position:absolute; top: 353px;
      left: 783px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/4-img7.png" id="4-img7">
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.fromTo(idOf("4-url"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("4-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("4-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("4-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("4-img4"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("4-img5"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("4-img6"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("4-img7"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg4Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "WWW.BASMAIGNEE.COM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `

      <img style="position:absolute; top: 90px;
      left: 427px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/5-t1.png" id="5-title">

      <img style="position:absolute; top: 48px;
      left: 750px; display: none;" class="1-title" src="/6ofthebest/chateaus/static/_content/5-contact.jpg" id="5-btn-text">

      <div class="addContentLink" style="bottom: 671px; left: 902px; width: 128px; height: 21px;
      ">


        <a href="http://www.chateaudeslys.nl" target="_blank"></a></div>

      
      <img style="position:absolute; top: 706px;
      left: 118px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/5-text.png" id="5-text">

      <img style="position:absolute; top: 48px;
      right: 17px;" onclick="fiveSlide()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/5-btn.jpg" id="5-contact">

      <div class="addContentLink" style="bottom: 126px;
      left: 226px;
      width: 273px;
      height: 16px;">
        <a href="http://www.channel4.com/programmes/escape-to-the-chateau-diy" target="_blank"></a></div>

        <div class="addContentLink" style="bottom: 89px;
        left: 769px;
        width: 122px;
        height: 16px;">
          <a href="http://www.chateauweddings.eu" target="_blank"></a></div>

          <div class="addContentLink" style="bottom: 70px;
          left: 360px;
          width: 191px;height: 16px;">
            <a href="http://mychateau.one/" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.fromTo(idOf("5-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("5-text"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.4")
        }

        function onPageLeave() {
          pg5Anim.stop();
          removeContentLinks();
        }

        function fiveSlide() {
          var x = document.getElementById("5-btn-text");
          if (x.style.display === "none" ) {
              x.style.display = "block";
              
          } else {
              x.style.display = "none";
          }
       }
      `,
      "searchText": "phone  As seen in the Channel 4 series Escape to the Château DIY, the Château des Lys is a 19th century ex-hunting lodge overlooks the picturesque Somme Estuary; and is only 1 hour south of Calais. Whether you’re planning an intimate informal gathering, a vintage bohemian country wedding, or that no holds barred party to end all parties, the Château des Lys is the perfect location. The owners offer a range of Wedding packages to suit you and your budget. They are also selling affordable co- housing shares in a couple of Gites fashioned from the old Chateau des Lys smithy.  Contact  Château des Lys"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 664px;
      left: 195px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-url.png" id="6-url">
      <div class="addContentLink" style="bottom: 114px;
      left: 192px;
width: 799px;
      height: 71px;
      ">
        <a href="http://www.chateauweddings.eu" target="_blank"></a></div>

      <img style="position:absolute; top: 140px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img1.png" id="6-img1">
      <img style="position:absolute; top: 346px;
      left: 98px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img2.png" id="6-img2">
      <img style="position:absolute; top: 309px;
      left: 330px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img3.png" id="6-img3">
      <img style="position:absolute; top: 120px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img4.png" id="6-img4">
      <img style="position:absolute; top: 305px;
      left: 548px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img5.png" id="6-img5">
      <img style="position:absolute; top: 93px;
      left: 723px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img6.png"  id="6-img6">
      <img style="position:absolute; top: 353px;
      left: 783px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/6-img7.png" id="6-img7">
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.fromTo(idOf("6-url"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("6-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("6-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("6-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("6-img4"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("6-img5"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("6-img6"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("6-img7"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg6Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "WWW.CHATEAUWEDDINGS.EU"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `

      <img style="position:absolute; top: 46px;
      left: 387px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/7-t1.png" id="7-title" >

      <img style="position:absolute; top: 0px;
      left: 791px; display: none;" class="1-title" src="/6ofthebest/chateaus/static/_content/7-contact.jpg" id="7-btn-text" >

      <div class="addContentLink" style="bottom: 714px; left: 948px; width: 168px; height: 21px;">
        <a href="http://www.chateaudubailleul.com" target="_blank"></a></div>

      <img style="position:absolute; top: 696px;
      left: 153px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/7-text.png" id="7-text">

      <img style="position:absolute; top: 0px;
      right: -35px;" onclick="sevenSlide()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/7-btn.jpg" id="7-contact">


      <div class="addContentLink" style="bottom: 137px;
      left: 698px;
      width: 178px;
      height: 16px;">
        <a href="http://www.channel4.com/programmes/escape-to-the-chateau-diy" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(idOf("7-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("7-text"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.4")
        }

        function onPageLeave() {
          pg7Anim.stop();
          removeContentLinks();
        }

        function sevenSlide() {
          var x = document.getElementById("7-btn-text");
          if (x.style.display === "none" ) {
              x.style.display = "block";
              
          } else {
              x.style.display = "none";
          }
       }

      `,
      "searchText": "At Château Du Bailleul we offer informal home stays where you can explore what this fantastic area has to offer, experience the reality of life in a Château with us or simply relax on the terrace with a glass of wine. We can supply the venue as a blank canvas or provide all the help and assistance to make your special day dreams come true.  phone  Château Du Bailleul is an 18th Century French Château in Pays De La Loire, featured on ‘Escape to the Château: DIY’, available as a wedding and event venue to suit all budgets, filming location, homestay accommodation and volunteering projects.  Contact  Château du Bailleul"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.png",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 664px;
      left: 158px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-url.png" id="8-url">
      <div class="addContentLink" style="bottom: 114px;
      left: 156px;
      width: 889px;
      height: 71px;
      ">
        <a href="http://www.chateaudubailleul.com" target="_blank"></a></div>

      <img style="position:absolute; top: 140px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img1.png" id="8-img1">
      <img style="position:absolute; top: 346px;
      left: 98px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img2.png" id="8-img2">
      <img style="position:absolute; top: 120px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img4.png" id="8-img3">
      <img style="position:absolute; top: 305px;
      left: 548px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img5.png" id="8-img4">
      <img style="position:absolute; top: 93px;
      left: 723px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img6.png" id="8-img5">
      <img style="position:absolute; top: 353px;
      left: 783px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img7.png" id="8-img6">
      <img style="position:absolute; top: 309px;
      left: 330px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/8-img3.png" id="8-img7">
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(idOf("8-url"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("8-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("8-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("8-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("8-img4"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("8-img5"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("8-img6"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("8-img7"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg8Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "WWW.CHATEAUDUBAILLEUL.COM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 86px;
      left: 357px; " class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/9-t1.png" id="9-title">

      <img style="position:absolute; top: 48px;
      left: 750px; display: none;" class="1-title" src="/6ofthebest/chateaus/static/_content/9-contact.jpg" id="9-btn-text">

      <div class="addContentLink" style="bottom: 686px; left: 889px; width: 98px; height: 21px;">
        <a href="http://www.tennessus.com" target="_blank"></a></div>

      <img style="position:absolute; top: 701px;
      left: 136px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/9-text.png" id="9-text">

      <img style="position:absolute; top: 48px;
      right: 17px;" onclick="nineSlide()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/9-btn.png" id="9-contact">


      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(idOf("9-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("9-text"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.4")
        }

        function onPageLeave() {
          pg9Anim.stop();
          removeContentLinks();
        }

        function nineSlide() {
          var x = document.getElementById("9-btn-text");
          if (x.style.display === "none" ) {
              x.style.display = "block";
              
          } else {
              x.style.display = "none";
          }
       }

      `,
      "searchText": "phone  Set in the heart of historic Poitou and entirely surrounded by water, Château de Tennessus is a stunning, fully restored, medieval castle B&B where time stands still, and only the plumbing is comfortingly modern. Built over 600 years ago (supposedly to keep out the English!) and dominated by an imposing rectangular keep (housing three enormous B&B rooms), Tennessus castle is totally authentic, with original stone spiral staircases, arrow slits, hoardings, bare stone walls and a working drawbridge!  Contact  Château de Tennessus"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.png",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 679px;
      left: 293px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-url.png" id="10-url">
      <div class="addContentLink" style="bottom: 100px;
      left: 289px;
      width: 629px;
      height: 71px;
      ">
        <a href="http://www.tennessus.com" target="_blank"></a></div>

      <img style="position:absolute; top: 150px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img1.png" id="10-img1">
      <img style="position:absolute; top: 356px;
      left: 98px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img2.png" id="10-img2">
      <img style="position:absolute; top: 319px;
      left: 330px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img3.png" id="10-img3">
      <img style="position:absolute; top: 130px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img4.png" id="10-img4">
      <img style="position:absolute; top: 315px;
      left: 548px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img5.png" id="10-img5">
      <img style="position:absolute; top: 103px;
      left: 723px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img6.png" id="10-img6">
      <img style="position:absolute; top: 363px;
      left: 783px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/10-img7.png" id="10-img7">
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.fromTo(idOf("10-url"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("10-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("10-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("10-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("10-img4"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("10-img5"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("10-img6"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          .fromTo(idOf("10-img7"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg10Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "WWW.TENNESSUS.COM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `

      <img style="position:absolute; top: 92px;
      left: 382px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/11-t1.png" id="11-title">

      <img style="position:absolute; top: 48px;
      left: 739px; display: none;" class="1-title" src="/6ofthebest/chateaus/static/_content/11-contact.jpg" id="11-btn-text">

      <div class="addContentLink" style="bottom: 677px;left: 896px; width: 178px; height: 21px; ">
        <a href="http://www.le-castel-normandy.com" target="_blank"></a></div>

      <img style="position:absolute; top: 707px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/11-text.png" id="11-text">

      <img style="position:absolute; top: 48px;
      right: 17px;" onclick="elevenSlide()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/11-btn.jpg" id="11-contact">


      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.fromTo(idOf("11-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("11-text"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.4")
        }

        function onPageLeave() {
          pg11Anim.stop();
          removeContentLinks();
        }

        function elevenSlide() {
          var x = document.getElementById("11-btn-text");
          if (x.style.display === "none" ) {
              x.style.display = "block";
              
          } else {
              x.style.display = "none";
          }
       }

      `,
      "searchText": "phone  Le Castel is a classic Napoleon III Château in Normandy offering Bed and Breakfast plus some rather special family holidays in school breaks. We specialise in all-inclusive family holidays in July and August, but at other times we are a normal Chambre d’Hotes (guest house) for adults, which is a friendlier and more relaxed environment than a hotel. Le Castel is luxurious for adults, whilst fun for kids.  Contact  Le Castel Normandy"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.png",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 665px;
      left: 210px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-url.png" id="12-url">
      <div class="addContentLink" style="bottom: 115px;
      left: 203px;
      width: 779px;
      height: 71px;
      ">
        <a href="http://www.le-castel-normandy.com" target="_blank"></a></div>

      <img style="position:absolute; top: 150px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img1.png" id="12-img1">
      <img style="position:absolute; top: 356px;
      left: 98px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img2.png" id="12-img2">
      <img style="position:absolute; top: 319px;
      left: 330px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img3.png" id="12-img3">
      <img style="position:absolute; top: 130px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img4.png" id="12-img4">
      <img style="position:absolute; top: 315px;
      left: 548px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img5.png" id="12-img5">
      <img style="position:absolute; top: 103px;
      left: 723px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img6.png" id="12-img6">
      <img style="position:absolute; top: 363px;
      left: 783px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/12-img7.png" id="12-img7">
      `,
      "script": `
        function onPageEnter() {
            pg12Anim = new TimelineMax();
            pg12Anim.fromTo(idOf("12-url"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
            .fromTo(idOf("12-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("12-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("12-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("12-img4"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("12-img5"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("12-img6"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("12-img7"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg12Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "LE-CASTEL-NORMANDY.COM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `

      <img style="position:absolute; top: 90px;
      left: 402px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/13-t1.png" id="13-title">

      <img style="position:absolute; top: 48px;
      left: 738px; display: none;" class="1-title" src="/6ofthebest/chateaus/static/_content/13-contact.jpg" id="13-btn-text">
      <div class="addContentLink" style="bottom: 667px; left: 896px; width: 158px; height: 21px;">
        <a href="http://www.chateauribagnac.com" target="_blank"></a></div>

      <img style="position:absolute; top: 724px;
      left: 136px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/13-text.png" id="13-text">

      <img style="position:absolute; top: 48px;
      right: 17px;" onclick="thirteenSlide()" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/13-btn.png" id="13-contact">

      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.fromTo(idOf("13-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
          .fromTo(idOf("13-text"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.4")
        }

        function onPageLeave() {
          pg13Anim.stop();
          removeContentLinks();
        }

        function thirteenSlide() {
          var x = document.getElementById("13-btn-text");
          if (x.style.display === "none" ) {
              x.style.display = "block";
              
          } else {
              x.style.display = "none";
          }
       }

      `,
      "searchText": "phone  Château Ribagnac is more than a romantic castle that has been lovingly converted into chambres d’hôtes; it is a breathtaking country retreat. Built in around 1560, the Château has accumulated character and style over the ages. It perfectly combines the charm and atmosphere of the old with the comfort and convenience of the modern. The Château is situated in its own grounds with stunning views across the valley.  Contact  Château Ribagnac"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 665px;
      left: 179px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-url.png" id="14-url">
      <div class="addContentLink" style="bottom: 115px;left: 176px;width: 830px;      height: 71px;
      ">
        <a href="http://www.chateauribagnac.com" target="_blank"></a></div>

      <img style="position:absolute; top: 150px;
      left: 157px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img1.png" id="14-img1">
      <img style="position:absolute; top: 356px;
      left: 98px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img2.png" id="14-img2">
      <img style="position:absolute; top: 319px;
      left: 330px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img3.png" id="14-img3">
      <img style="position:absolute; top: 130px;
      left: 451px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img4.png" id="14-img4">
      <img style="position:absolute; top: 315px;
      left: 548px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img5.png" id="14-img5">
      <img style="position:absolute; top: 103px;
      left: 723px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img6.png" id="14-img6">
      <img style="position:absolute; top: 363px;
      left: 783px;" class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/14-img7.png" id="14-img7">
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
            pg14Anim.fromTo(idOf("14-url"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
            .fromTo(idOf("14-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("14-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("14-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("14-img4"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("14-img5"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("14-img6"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("14-img7"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg14Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "WWW.CHATEAURIBAGNAC.COM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 64px;
      left: 252px;
      " class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/15-t1.png" id="15-title">

      <img style="position:absolute; top: 366px;
      left: 78px;
      " class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/15-img1.jpg" id="15-img1">
      <img style="position:absolute; top: 356px;
      left: 453px;
      " class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/15-img2.png" id="15-img2">
      <img style="position:absolute; top: 382px;
      left: 816px;
      " class="1-title halfScale" src="/6ofthebest/chateaus/static/_content/15-img3.png" id="15-img3">

      <div class="addContentLink" style="bottom: 90px;
      left: 474px;
      width: 250px;
      height: 41px;
      ">
        <a href="http://www.sotb.online/" target="_blank"></a></div>

        <div class="addContentLink" style="bottom: 35px;
        left: 436px;
        width: 330px;
        height: 41px;
        ">
          <a href="http://www.ironstone.ltd" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
           pg15Anim = new TimelineMax();
            pg15Anim.fromTo(idOf("15-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)
            .fromTo(idOf("15-img1"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("15-img2"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
            .fromTo(idOf("15-img3"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg15Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Six Of The Best is presented to you by Ironstone Software LTD SIX OF THE BEST  We are a software development company based in Northamptonshire. We design and build websites, digital magazines and bespoke software tailored to you, to bring the best out of your business. There are two things we want you to know - we treat every job like its our first and we will help in any way we can.  WWW.SOTB.ONLINE WWW.IRONSTONE.LTD"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var thisPage = document.querySelector('.currentPage') 
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var thisPage = document.querySelector('.currentPage') 
        var contentLinks = [].slice.call(thisPage.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js